import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { UpsertTaskModal } from "../../../features/task-upsert";
import { StickyFilterBar } from "../../../shared/ui/layouts/StickyFilterBar";
import { AufgabenFilterBar } from "./ui/AufgabenFilterBar";
import { AufgabenList } from "./ui/AufgabenList";
import { TaskButtons } from "./ui/TaskButtons";

export const AufgabenPage = () => {
  return (
    <>
      <PageLayout
        pageTitle="Aufgaben"
        headerChildren={<TaskButtons />}
      >
        <div className="flex w-full flex-col gap-4">
          <StickyFilterBar>
            <AufgabenFilterBar />
          </StickyFilterBar>
          <AufgabenList />
        </div>
      </PageLayout>

      {/*
        Mounted once for the whole page: the menu and every list row only write the URL, and the
        modal reads it. That is also what makes `/aufgaben?upsert-task=edit&upsert-task-id=42`
        a working deep link from anywhere else in the app.
      */}
      <UpsertTaskModal />
    </>
  );
};
